import React from 'react';
import PropTypes from 'prop-types';
// Material UI
import MuiClickAwayListener from '@material-ui/core/ClickAwayListener';
import MuiGrow from '@material-ui/core/Grow';
import MuiPopper from '@material-ui/core/Popper';
import MuiPaper from '@material-ui/core/Paper';

const Popper = ({
  open, anchorEl, placement, children, onClose,
}) => {
  // Components props
  const popoverProps = { open, anchorEl, placement };

  return (
    <MuiPopper
      {...popoverProps}
      style={{ zIndex: 100 }}
      transition
      modifiers={{
        computeStyle: {
          gpuAcceleration: false,
        },
      }}
    >
      {({ TransitionProps }) => (
        <MuiGrow {...TransitionProps}>
          <MuiPaper>
            <MuiClickAwayListener onClickAway={onClose}>
              {children}
            </MuiClickAwayListener>
          </MuiPaper>
        </MuiGrow>
      )}
    </MuiPopper>
  );
};

Popper.propTypes = {
  open: PropTypes.bool.isRequired,
  anchorEl: PropTypes.object,
  placement: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired,
};

Popper.defaultProps = {
  anchorEl: null,
};

export default React.memo(Popper);



// WEBPACK FOOTER //
// ./components/core/Popper.js